var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 95,
    viewBox: "0 0 84 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.56 39.163L50.0875 42.8733L41.998 38.2399V30.8284L56.56 39.163Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.0001 30.8284V38.2399L33.9061 42.8733L27.4336 39.163L42.0001 30.8284Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M56.56 39.163L50.0875 42.8733L41.998 38.2399V30.8284L56.56 39.163Z",
    fill: "url(#paint0_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.0001 30.8284V38.2399L33.9061 42.8733L27.4336 39.163L42.0001 30.8284Z",
    fill: "url(#paint1_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.56 39.163L50.0875 42.8733L41.998 38.2399V30.8284L56.56 39.163Z",
    fill: "url(#paint2_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M42.0001 64.1741V56.7625L33.9061 52.1337L27.4336 55.8394L42.0001 64.1741Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.998 64.1741L56.56 55.8394L50.0875 52.1337L41.998 56.7625V64.1741Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.998 64.1741L56.56 55.8394L50.0875 52.1337L41.998 56.7625V64.1741Z",
    fill: "url(#paint3_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.0001 64.1741V56.7625L33.9061 52.1337L27.4336 55.8394L42.0001 64.1741Z",
    fill: "url(#paint4_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.4336 55.816L34.6419 51.6914L27.4336 51.0656V55.816Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M27.4336 39.5917V47.3409L34.0242 43.3875L27.4336 39.5917Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M56.573 47.7983V55.5476L49.9824 51.5897L56.573 47.7983Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27.4336 47.3362L49.9715 51.5869L56.562 47.7955L34.0242 43.3828L27.4336 47.3362Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M83.4991 23.7476L48.9883 43.213H83.4991V23.7476Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M41.998 0V21.1135L65.0492 34.3066L83.4946 23.7476L41.998 0Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M42.0011 0L0.5 23.7476L18.95 34.3066L42.0011 21.1135V0Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M0.5 23.7476V71.2563L18.95 60.6973V34.3066L0.5 23.7476Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.95 60.6887L42.0011 73.8818V94.9998L0.5 71.2477L18.95 60.6887Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M65.0492 60.6887L83.4946 71.2477L41.998 94.9998V73.8818L65.0492 60.6887Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M41.998 0V21.1135L65.0492 34.3066L83.4946 23.7476L41.998 0Z",
    fill: "url(#paint5_linear_1037_2723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M18.95 60.6887L0.5 71.2477L42.0011 94.9998V73.8818L18.95 60.6887Z",
    fill: "url(#paint6_linear_1037_2723)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1037_2723",
    x1: 45.5318,
    y1: 33.3229,
    x2: 53.7149,
    y2: 45.2678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1037_2723",
    x1: 36.3316,
    y1: 37.7581,
    x2: 23.7037,
    y2: 44.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1037_2723",
    x1: 44.2146,
    y1: 34.9844,
    x2: 67.8457,
    y2: 52.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1037_2723",
    x1: 41.998,
    y1: 58.1539,
    x2: 56.56,
    y2: 58.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1037_2723",
    x1: 38.4663,
    y1: 61.675,
    x2: 30.2832,
    y2: 49.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1037_2723",
    x1: 52.0633,
    y1: 7.10988,
    x2: 75.3872,
    y2: 41.1424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1037_2723",
    x1: 0.5,
    y1: 77.8443,
    x2: 42.0011,
    y2: 77.8443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logoBlue.19e0ef707de864d1e765f8afa072d3cb.svg";
export { ForwardRef as ReactComponent };